import { DsmAddendumOptionTax } from './dsm-addendum-state.models';
import { DsmAddendumTypeSummary, DsmBuilderReferenceSummary, DsmProductUomSummary } from './dsm-deal-options.models';
import type { DsmAddendumSignOffStatus } from './dsm-addendum-sign-off.models';
import type { DsmPendingLocationRule } from './dsm-room-replacement-rule.models';
import { TaxCategoryDto } from '@zayan-erp/home-building';

export enum DiscountType {
  Amount = 'edb4a381-a8ff-48f5-9196-73958cee7757',
  Percentage = '4e02679c-8265-4b25-b33c-0f16f3eb76d5'
}

export enum DsmAddendumsQueryParam {
  Addendum = 'addendum',
  Option = 'option'
}

export interface DsmDealOption {
  id: string;
  lotId: string;
  seq: number;
  documentDate: string;
  buyerApproved: boolean;
  builderApproved: boolean;
  buyerApprovedDate: string | null;
  builderApprovedDate: string | null;
  inContract: boolean;
  cash: boolean;
  includeInAps: boolean;
  total: number;
  optionsTotal: number;
  discountsTotal: number;
  taxesTotal: number;
  incentivesTotal: number;
  notes: string | null;
  builderReference: DsmBuilderReferenceSummary;
  addendumType: DsmAddendumTypeSummary;
  products: DsmDealOptionProduct[];
  isCancelled: boolean;
  isLocked: boolean;
  paymentsReceived?: number;
  createdByUserId?: string | null;
  createdByUserFullName?: string | null;
  createdAt?: string | null;
  lastModified?: string | null;
  signOff?: DsmAddendumSignOffStatus | null;
  pendingLocationRules: DsmPendingLocationRule[];
}

export interface DsmDealOptionProductAttribute {
  subCategoryAttributeId: string;
  subCategoryAttribute: string;
  subCategoryAttributeValues: Array<DsmDealOptionProductAttributeValues>;
}

export interface DsmDealOptionProductAttributeValues {
  subCategoryAttributeValueId: string;
  subCategoryAttributeValue: string;
}

export interface DsmDealOptionProduct {
  id: string;
  productId: string;
  productDescription?: string | null;
  salesDescription: string | null;
  modelElevationProductsId: string;
  productCode: string;
  notes: string;
  selectedLocationId: string | null;
  locationName: string;
  locationCode: string | null;
  unitPrice: number;
  quantity: number;
  retailCredit: number;
  incentiveAmount: number;
  discountPercentage: number;
  discount: number;
  discountTypeId: DiscountType;
  discountValue: number;
  productTypeId: string | null;
  productTypeName: string | null;
  productClassId: string | null;
  productClassName: string | null;
  categoryName: string | null;
  subcategoryName: string | null;
  taxCategory: TaxCategoryDto | null;
  taxes: DsmAddendumOptionTax[];
  uofm: DsmProductUomSummary | null;
  lineNumber: number | null;
  attributes: DsmDealOptionProductAttribute[];
  linkedProducts: DsmDealOptionProduct[];
  amount: number;
  total: number;
  isCancelled: boolean;
  productImages: any[];
  /** Room Replacement Rules: true when this product triggers a rule on the home's model + elevation. */
  roomReplacementRuleExists?: boolean;
}

export interface DsmUpdateDealAddendumPayload {
  builderReferenceId: string;
  notes: string;
  inContract: boolean;
  cash: boolean;
  includeInAps: boolean;
}

export interface DsmAddendumOptionsPayload {
  modelElevationProductsId: string;
  selectedLocationId: string | null;
  unitPrice: number;
  notes?: string;
  quantity?: number;
  attributes: {
    subCategoryAttributeId: string;
    subCategoryAttributeValueId: string;
  }[];
}

export interface DsmGenerateAddendumPdfRequest {
  addendumIds: string[];
  selectedOptionIds: number[];
  forSigningPreview: boolean;
}

export interface DsmPrintAddendumOption {
  id: number;
  name: string;
  label: string;
  isDefault: boolean;
}
